<template lang="pug">
#projectsWeb
  br
  br
  .row
    .container
      .row.center
        p.Fjalla.largerSize Projects
      .col#projectList
        ul
          li(@click="selected='new'" v-bind:class="{active: selected=='new'}") New Project
          li(v-for="p in projects" @click="selectProject(p.name)" :class="{active: selected==p.name}") {{p.name}}
      .col.s2
      .col.s6.Oswald.valign-wrapper(v-if="selected=='new'")
        .card(style="width:100%")
          .card-content
            .row
              input.Fjalla.center(type="text" placeholder="New Project" v-model="newPj.name")
              br
            .row
              ul.collection
                li.collection-item
                  input(type="text" v-model="newPj.newKW" @keyup.enter="addKW(newPj)")
                  i.material-icons(v-on:click="addKW(newPj)") add
                  li.collection-item(v-for="(w, i) in newPj.brandQuery.split(',')" v-if="w!=''")
                    p {{w.replace(/"/g, "")}}
                      i.material-icons(v-on:click="removeKW(newPj, i)") close
            .row()
              .btn.red.lighten-2(@click="cancelNewPj()") Cancel
              span  . .
              .btn(@click="saveNewPj(newPj)") Save
      .col.s6.Oswald.valign-wrapper(v-for="p in projects" v-if="selected==p.name")
        .card(style="width:100%")
          .card-content
            .row
              .col
                .switch()
                  label
                    input(type="checkbox" v-model="p.active" v-on:click="toggleProject(p.name)")
                    span.lever
              .col
                p.Fjalla {{p.name}}
                  small(@click="$router.push('/client/'+p.name)")  _
                    i(class="material-icons") business
                br
            .row
              ul.collection
                li.collection-item
                  input(type="text" v-model="p.newKW" @keyup.enter="addKW(p)")
                  i.material-icons(v-on:click="addKW(p)") add
                li.collection-item(v-for="(w, i) in p.brandQuery.split(',')"  v-if="w!=''")
                  p {{w.replace(/"/g, "")}}
                    i.material-icons(v-on:click="removeKW(p, i)") close
                li.collection-item
                  input#instagramTag(type="text" style="width: calc(100% - 25px)")
                  img(src="http://moziru.com/images/logo-clipart-instagram-6.png" style="width: 25px" @click="extractInstagramPost()")
                  textarea#codeInput(style="opacity: 0; position: absolute; z-index: 0")
            .row(v-if="p.changes")
              .btn.red.lighten-2(@click="cancelPj(p)") Cancel
              span . .
              .btn(@click="savePj(p)") Save
  .row
    project(:selected="selected" v-if="selected!='' && selected!='new'" :key="selected")
</template>

<script>
import project from '@/components/project';

var newPj = {
  name: "",
  brandQuery: "",
  changes: false,
}
//var baseUrl = window.location.hostname == "localhost" ? "http://localhost:5500" : "";
var baseUrl = "https://loversnothaters.com";
export default {
  data(){
    return {
      projects: {},
      _projects: {},
      selected: "",
      newPj: JSON.parse(JSON.stringify(newPj)),
    }
  },
  components:{
    project
  },
  mounted(){
    axios.get(baseUrl + "/projects/").then(({data})=>{
      this.projects = data;
      this._projects = JSON.parse(JSON.stringify(data)); //save
    }).catch(console.error);
    this.selected = this.$route.params.project || ""
  },
  methods:{
    toggleProject(p){
      console.log(p, this.projects[p].active)
      var strAction = !this.projects[p].active ? "stopProject/" : "startProject/";
      axios.get(baseUrl + "/projects/" + strAction + p).then(({data})=>{
        Object.keys(this.projects).forEach((pj)=>{
          this.projects[pj].active = false;
        });
        console.log(data)
        data.forEach((p)=>{
          this.projects[p].active = true;
        });
      }).catch(console.error);
    },
    addKW(p){
      if(p.newKW=="") return 0;
      p.brandQuery += (p.brandQuery != "" ? ',"' : '"') + p.newKW + '"';
      p.changes = true;
      p.newKW = "";
    },
    removeKW(p, i){
      var t = [];
      p.brandQuery.split(",").forEach((w, j)=>{
        if(i!=j) t.push(w)
      });
      p.brandQuery = t.join(",");
      p.changes = true;
    },
    savePj(p){
      if(p.brandQuery == "") return 0;
      this.projects[p.name].changes = false;
      axios.get(baseUrl + "/projects/changeProjectQuery/" + p.name + "/" + p.brandQuery)
      .then(({data})=>{
        console.log(data);
      }).catch(console.error);
      this._projects[p.name] = JSON.parse(JSON.stringify(this.projects[p.name]));
    },
    cancelPj(p){
      console.log(p, this._projects[p.name])
      this.projects[p.name] = JSON.parse(JSON.stringify(this._projects[p.name]));
    },
    saveNewPj(p){
      console.log(p)
      if(p.brandQuery == "" || p.name == "") return 0;
      axios.get(baseUrl + "/projects/newProject/" + p.name + "/" + p.brandQuery)
      .then(({data})=>{
        console.log(data);
      }).catch(console.error);
      this.$set(this.projects, p.name, p)
      this._projects[p.name] = JSON.parse(JSON.stringify(p));
      this.projects[p.name].changes = false;
    },
    cancelNewPj(p){
      this.newPj = JSON.parse(JSON.stringify(newPj));
    },
    selectProject(p){
      this.selected = p;
      this.$router.push('/dashboard/' + p)
    },
    extractInstagramPost(){
      //need to change address to actual domain, for test propposes
      var code = `
      var SaveData = function(project, tag){
        var jq = document.createElement('script');
        jq.src = "https://ajax.googleapis.com/ajax/libs/jquery/2.1.4/jquery.min.js";
        document.getElementsByTagName('head')[0].appendChild(jq);

        var times = 60;
        var scroll = function(){
          if(times){
            setTimeout( ()=>{
              var NoPost = jQuery("._fd86t")[0].innerText;
              var tag = jQuery("._kwqc3")[0].innerText;
              var records = [];
              var imgs = jQuery("._mck9w a");
              imgs.toArray().forEach((p)=>{
                records.push({url: p.href});
              })
              var imgs = jQuery("._mck9w img");
              imgs.toArray().forEach((p, i)=>{
                records[i].image = p.src;
                records[i].text = p.alt;
              });
              records.forEach((r)=>{
                var temp = r.url.slice(r.url.indexOf('/p/')+3);
                r.id = temp.slice(0, temp.indexOf('/'));
                r.project = project;
                r.brandQuery = tag;
                jQuery.post("https://loversnothaters.com/projects/postInstagram/" + r.project, r, ()=>{});
              });
              window.scrollTo(0,document.body.scrollHeight);
              times--;
              setTimeout(scroll, 500);
            }, 3000);
          } else {
            alert("done")
          }
        }
        scroll();
      }

      SaveData("${this.selected}", "#${jQuery('#instagramTag')[0].value}")
      `;
      jQuery('#codeInput')[0].value = code;
      var copyText = document.getElementById("codeInput");
      copyText.select();
      document.execCommand("Copy");
      window.open('https://www.instagram.com/explore/tags/'+ jQuery('#instagramTag')[0].value + '/', '_blank');
    }
  }
}
</script>

<style lang="sass" scoped>
#projectsWeb
  background-color: #EEE
  padding-bottom: 10px
  margin-bottom: -10px
  min-height: 100vh
  font-size: 50%

.chip
  display: inline
  vertical-align: baseline
  font-size: 70%

.collection
  .collection-item
    position: relative
  p
    padding-right: 20px
  i
    position: absolute
    right: 10px
    top: 50%
    transform: translate(0, -50%)
input
  margin: 0 !important
  padding: 0
  font-size: inherit !important
.newPj
  width: 100%

#projectList
  font-size: 90%
  li
    color: #999
    &.active
      color: #000

</style>



// WEBPACK FOOTER //
// src/components/projects.vue